<div class="shared-banner">
  <div class="shared-banner__header" (click)="toggle()">
    <div class="shared-banner__left">
      <span class="shared-banner__dot"></span>
      <p class="shared-banner__text">
        Alcuni campi sono condivisi con gli altri profili del caregiver.
        Salvando, le modifiche verranno applicate automaticamente a tutti.
      </p>
    </div>
    <button class="shared-banner__toggle">
      {{ expanded ? "Nascondi" : "Vedi campi" }}
      <span class="shared-banner__arrow" [class.rotated]="expanded">▼</span>
    </button>
  </div>

  <div class="shared-banner__details" *ngIf="expanded">
    <div class="shared-banner__divider"></div>
    <div class="shared-banner__grid">
      <div *ngFor="let section of sections" class="shared-banner__section">
        <span class="shared-banner__section-title">{{ section.label }}</span>
        <span class="shared-banner__section-fields">{{ section.fields }}</span>
      </div>
    </div>
  </div>
</div>
